const matchhoroscope = {
  // Header Section
  "kundli_matching_service": "குண்டலி பொருத்த சேவை",
  "match_your": "உங்கள்",
  "horoscopes": "குண்டலி",
  "for_perfect_union": "செருக்கான இணைவிற்காக",
  "match_horoscope_description": "அசல் வேத ஜோதிடத்தின் மூலம் உங்கள் இணக்கத் தன்மையை அறியுங்கள். 36 குணங்களின் முறைப்படியான (குண மிலான்) பகுப்பாய்வின் மூலம் திருமண ஒற்றுமையும் உறவு வெற்றியும் மதிப்பிடப்படுகிறது.",

  // Form Fields
  "partner_1_details": "கணவன்/பங்குதாரர் 1 விவரங்கள்",
  "partner_2_details": "மனைவி/பங்குதாரர் 2 விவரங்கள்",
  "male_groom": "ஆண்/மாப்பிள்ளை",
  "female_bride": "பெண்/மணமகள்",
  "enter_groom_name": "மாப்பிள்ளையின் முழுப் பெயரை உள்ளிடுங்கள்",
  "enter_bride_name": "மணமகளின் முழுப் பெயரை உள்ளிடுங்கள்",
  "full_name": "முழுப் பெயர்",
  "gender": "பாலினம்",
  "male": "ஆண்",
  "female": "பெண்",
  "date_time_of_birth": "பிறந்த தேதி & நேரம்",
  "place_of_birth": "பிறந்த இடம்",
  "enter_partner_name": "பங்குதாரரின் பெயரை உள்ளிடுங்கள்",
  "city_state_country": "நகரம், மாநிலம், நாடு",
  "email_address": "மின்னஞ்சல் முகவரி",
  "phone_number": "தொலைபேசி எண்",
  "enter_email_for_report": "விரிவான அறிக்கைக்கான மின்னஞ்சலை உள்ளிடுங்கள்",
  "enter_phone": "உங்கள் தொலைபேசி எண்ணை உள்ளிடுங்கள்",
  "contact_details_info": "தொடர்பு விவரங்களை வழங்குவதன் மூலம், உங்கள் இணக்க அறிக்கையை நேரடியாகப் பெறுவீர்கள்.",
  "service_pricing": "சேவை கட்டணம்",
  "complete_horoscope_matching": "முழுமையான குண்டலி பொருத்த பகுப்பாய்வு",
  "one_time_payment_info": "நிபுணர் ஜோதிடர்களால் செய்யப்படும் முழுமையான பொருத்தப் பகுப்பாய்விற்கான ஒருமுறை கட்டணம்",
  "detailed_compatibility_analysis": "விரிவான இணக்கத் தன்மை பகுப்பாய்வு",
  "guna_milan_36_points": "குண மிலான் (36 புள்ளிகள் முறை)",
  "manglik_dosha_analysis": "மங்கள தோஷம் பகுப்பாய்வு",
  "future_predictions_couple": "இணைக்கான எதிர்கால முன்கணிப்புகள்",
  "remedial_solutions": "பரிகாரத் தீர்வுகள் & பரிந்துரைகள்",
  "pdf_report_download": "PDF அறிக்கை பதிவிறக்கம்",
  "contact_information": "தொடர்பு தகவல்",

  // Actions
  "match_horoscopes_now": "இப்போது குண்டலிகளை பொருத்தவும்",
  "matching_horoscopes": "குண்டலி பொருத்தம் நடக்கிறது",
  "pay_and_match": "கட்டணம் செலுத்தி பொருத்தவும்",
  "processing_payment": "கட்டணம் செயலாக்கப்படுகிறது...",
  "dd_mm_yyyy_time_format": "DD/MM/YYYY மற்றும் HH:MM (12-மணி) AM/PM வடிவில் உள்ளிடுங்கள்",
  "am": "காலை (AM)",
  "pm": "மாலை (PM)",
  "dd_placeholder": "DD",
  "mm_placeholder": "MM",
  "yyyy_placeholder": "YYYY",
  "hh_placeholder": "HH",

  // Results
  "compatibility_result": "இணக்கத் தன்மை முடிவு",
  "overall_compatibility": "மொத்த இணக்கத் தன்மை",
  "guna_milan_points": "குண மிலான் புள்ளிகள்",
  "match_status": "பொருத்த நிலை",
  "excellent_match": "மிகச் சிறந்த பொருத்தம்",
  "good_match": "நல்ல பொருத்தம்",
  "average_match": "சராசரி பொருத்தம்",
  "detailed_guna_analysis": "விரிவான குணப் பகுப்பாய்வு",

  // Actions
  "download_detailed_report": "விரிவான அறிக்கையை பதிவிறக்கவும்",
  "consult_astrologer": "ஜோதிடரை அணுகவும்",
  "match_another_couple": "மற்றொரு ஜோடியை பொருத்தவும்",

  // Features
  "what_our_matching_includes": "எங்கள் பொருத்த சேவையில் உள்ளவை",
  "36_guna_analysis": "36 குணங்கள் பகுப்பாய்வு",
  "36_guna_analysis_desc": "36 இணக்கப் புள்ளிகளின் முழுமையான மதிப்பீடு",
  "love_compatibility": "உங்கள் காதல் வாழ்க்கை",
  "love_compatibility_desc": "உணர்ச்சி & ரோமான்ஸ் ஒற்றுமை பகுப்பாய்வு",
  "family_harmony": "குடும்ப ஒற்றுமை",
  "family_harmony_desc": "நீண்டகால உறவு நிலைத்தன்மை முன்கணிப்பு",
  "manglik_dosha": "மங்கள தோஷச் சரிபார்ப்பு",
  "manglik_dosha_desc": "தோஷங்களை அடையாளம் கண்டு பரிகார வழிகாட்டுதல்",

  // Thank You Message
  "thank_you_submission": "உங்கள் சமர்ப்பிப்புக்கு நன்றி!",
  "data_received_message": "உங்கள் குண்டலி பொருத்தக் கோரிக்கை வெற்றிகரமாக பெறப்பட்டது. எங்கள் அனுபவம் வாய்ந்த ஜோதிடர்கள் இரு ஜாதகங்களையும் கவனமாக ஆய்வு செய்வார்கள்.",

  // Security & Timeline
  "your_data_secure": "உங்கள் தரவு 100% பாதுகாப்பானது",
  "data_security_message": "அனைத்து தனிப்பட்ட தகவல்களும் குறியாக்கம் செய்யப்பட்டு பாதுகாக்கப்படுகின்றன. உங்கள் விவரங்கள் மூன்றாம் தரப்புகளுடன் பகிரப்படமாட்டாது.",
  "response_within_12_hours": "12 மணிநேரத்தில் பதில்",
  "response_time_message": "எங்கள் நிபுணர்கள் உங்கள் விரிவான இணக்க அறிக்கையைத் தயாரித்து விரைவில் தொடர்பு கொள்வார்கள்.",

  // Support
  "need_immediate_help": "உடனடி உதவி தேவைதா?",
  "whatsapp_support": "WhatsApp ஆதரவு",
  "processing_request": "உங்கள் கோரிக்கை செயலாக்கப்படுகிறது",
  "back_to_home": "முகப்புக்கு திரும்ப"
};

export default matchhoroscope;
